export default {
  getApplicationSetting: (state) => state.applicationSetting,
};
